module.exports = "/images/en.svg";